import { render, staticRenderFns } from "./SpecialtySelector.vue?vue&type=template&id=6b278944&scoped=true"
import script from "./SpecialtySelector.vue?vue&type=script&lang=js"
export * from "./SpecialtySelector.vue?vue&type=script&lang=js"
import style0 from "./SpecialtySelector.vue?vue&type=style&index=0&id=6b278944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b278944",
  null
  
)

export default component.exports